export default __webpack_public_path__ + "static/media/data-storage.eaa2faf1.png";